import { JoinErrorEnum } from '../join-workspace/join-page/handleErrorMessage';

export class InviteError extends Error {
  readonly code: JoinErrorEnum;
  constructor(code?: JoinErrorEnum) {
    super();
    this.code = code || JoinErrorEnum.DEFAULT;
  }
}
